import React, {CSSProperties, ReactNode} from 'react';

interface FlexWrapperProps {
  justifyContent?: CSSProperties['justifyContent'];
  alignItems?: CSSProperties['alignItems'];
  dir?: CSSProperties['flexDirection'];
  gap?: CSSProperties['gap'];
  children: ReactNode | ReactNode[];
  className?: string;
}

const FlexWrapper = ({
                       justifyContent = 'initial',
                       alignItems = 'initial',
                       dir = 'row',
                       children,
                       gap = 0,
                       className = '',
                     }: FlexWrapperProps) => (
  <div
    className={className}
    style={{
      display: 'flex',
      justifyContent,
      alignItems,
      flexDirection: dir,
      gap,
    }}
  >
    {children}
  </div>
);

export default FlexWrapper;
